import { Component, Vue } from "vue-property-decorator";
import { Order } from "@/orders";

interface CommodityFormat {
  name: string;
  icon: string;
}
interface StatusFormat {
  description: string;
  icon: string;
  iconDetail: string;
  name: string;
  date?: string;
  code?: string;
}

declare module "vue/types/vue" {
  interface Vue {
    namedCommodities(name: string): CommodityFormat;
    namedStatus(code: string, order?: Order): StatusFormat;
  }
}

@Component({
  name: "vue.orders",
})
export default class VueOrders extends Vue {
  public namedCommodities(name: string): CommodityFormat {
    if (name === "DELIVERY") {
      return {
        name: this.$t("orders.commodities.delivery") as string,
        icon: require("@/orders/assets/icons/orders/icon-pedidos-entrega.svg") as string,
      };
    } else if (name === "DELIVERY_CHANGE") {
      return {
        name: this.$t("orders.commodities.deliveryChange") as string as string,
        icon: require("@/orders/assets/icons/orders/icon-pedidos-entrega-de-cambio.svg") as string,
      };
    } else if (name === "PICKUP") {
      return {
        name: this.$t("orders.commodities.pickup") as string,
        icon: require("@/orders/assets/icons/orders/icon-pedidos-recogida.svg") as string,
      };
    } else if (name === "SUPPLY") {
      return {
        name: this.$t("orders.commodities.supply") as string,
        icon: require("@/orders/assets/icons/orders/icon-pedidos-material-operativo.svg") as string,
      };
    } else if (name === "ASSISTANCE") {
      return {
        name: this.$t("orders.commodities.other") as string,
        icon: require("@/orders/assets/icons/orders/icon-pedidos-asistencia-tecnica.svg") as string,
      };
    }
    return {} as CommodityFormat;
  }

  public namedStatus(code: string, order?: Order): StatusFormat {
    if (code === "PEN" || code === "APR" || code === "NOT" || code === "PRE") {
      return {
        name: this.$t("orders.statuses.pen") as string,
        icon: require("@/orders/assets/icons/icon-calendar.svg") as string,
        iconDetail: require("@/orders/assets/icons/state/icon-state-calendar.svg") as string,
        description: this.$t("orders.statuses.penDescription") as string,
        date: order?.creationDate || "",
        code: "PEN",
      };
    } else if (code === "CON") {
      return {
        name: this.$t("orders.statuses.con") as string,
        icon: require("@/orders/assets/icons/icon-check-circle.svg") as string,
        iconDetail: require("@/orders/assets/icons/state/icon-state-check.svg") as string,
        description: this.$t("orders.statuses.conDescription") as string,
        date: order?.citConfirmDate || "",
        code: "CON",
      };
    } else if (code === "DEP") {
      return {
        name: this.$t("orders.statuses.dep") as string,
        icon: require("@/orders/assets/icons/icon-pedidos-white.svg") as string,
        iconDetail: require("@/orders/assets/icons/state/icon-state-car.svg") as string,
        description: this.$t("orders.statuses.depDescription") as string,
        date: order?.citDepartDate || "",
        code: "DEP",
      };
    } else if (code === "OTW" || code === "EXG") {
      return {
        name: this.$t("orders.statuses.otw") as string,
        icon: require("@/orders/assets/icons/icon-store.svg") as string,
        iconDetail: require("@/orders/assets/icons/state/icon-state-store.svg") as string,
        description: this.$t("orders.statuses.otwDescription") as string,
        date: order?.citDate || "",
        code: "OTW",
      };
    } else if (code === "CAN") {
      return {
        name: this.$t("orders.statuses.cancel") as string,
        icon: require("@/orders/assets/icons/icon-store.svg") as string,
        iconDetail: require("@/orders/assets/icons/state/icon-state-store.svg") as string,
        description: this.$t("orders.statuses.cancelDescription") as string,
        date: order?.citDate || "",
        code: "CAN",
      };
    } else {
      return {
        name: this.$t("orders.statuses.other") as string,
        icon: require("@/orders/assets/icons/icon-check-circle.svg") as string,
        iconDetail: require("@/orders/assets/icons/state/icon-state-check.svg") as string,
        description: this.$t("orders.statuses.otherDescription") as string,
        date: order?.citExecutedDate || "",
        code: "EXD",
      };
    }
  }
}
